import React from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Alert,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  Payments as PaymentsIcon,
  Person as PersonIcon,
  EventNote as EventNoteIcon,
  Warning as WarningIcon,
} from "@mui/icons-material";
import SummaryCard from "./SummaryCard";
import TrainerAccordionRow from "./TrainerAccordionRow";
import { formatCurrency } from "../utils/formatters";
import { GRADIENTS } from "../utils/gradients";

const TrainerPayouts = ({ payoutData, dateFrom, dateTo }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!payoutData) {
    return (
      <Typography variant="body1" color="text.secondary" sx={{ textAlign: "center", py: 4 }}>
        Brak danych do wyświetlenia
      </Typography>
    );
  }

  return (
    <>
      {payoutData.warnings && payoutData.warnings.length > 0 && (
        <Alert severity="warning" sx={{ mb: 3 }} icon={<WarningIcon />}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
            Uwagi dotyczące wypłat:
          </Typography>
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {payoutData.warnings.map((warning, index) => (
              <li key={index}>{warning}</li>
            ))}
          </ul>
        </Alert>
      )}

      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={4}>
          <SummaryCard
            icon={<PaymentsIcon />}
            label="Łącznie do wypłaty"
            value={formatCurrency(payoutData.total_payout)}
            gradient={GRADIENTS.green}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <SummaryCard
            icon={<EventNoteIcon />}
            label="Odbyte zajęcia"
            value={payoutData.total_lessons}
            caption="z min. 1 zapisanym uczestnikiem"
            gradient={GRADIENTS.blue}
          />
        </Grid>
      </Grid>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontWeight: 600, display: "flex", alignItems: "center" }}
        >
          <PersonIcon sx={{ mr: 1 }} />
          Wypłaty dla trenerów ({payoutData.trainers?.length || 0})
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Liczone wyłącznie zajęcia, które się odbyły (nieodwołane, z co najmniej
          jednym aktywnym zapisem). Zajęcia darmowe również się liczą. Kliknij
          trenera, aby zobaczyć rozbicie na poszczególne zajęcia.
        </Typography>
        {payoutData.trainers && payoutData.trainers.length > 0 ? (
          payoutData.trainers.map((row) => (
            <TrainerAccordionRow
              key={row.trainer_id}
              row={row}
              dateFrom={dateFrom}
              dateTo={dateTo}
              isMobile={isMobile}
            />
          ))
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", py: 2 }}>
            Brak odbytych zajęć w wybranym okresie
          </Typography>
        )}
      </Paper>
    </>
  );
};

export default TrainerPayouts;
